function canonicalize(value) {
    if (value === null || typeof value !== 'object')
        return value;
    if (Array.isArray(value))
        return value.map(canonicalize);
    const obj = value;
    const sorted = {};
    for (const key of Object.keys(obj).sort()) {
        const v = obj[key];
        if (v !== undefined)
            sorted[key] = canonicalize(v);
    }
    return sorted;
}
export function canonicalJson(state) {
    return JSON.stringify(canonicalize(state));
}
export async function computeStateHash(state) {
    const bytes = new TextEncoder().encode(canonicalJson(state));
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    const arr = new Uint8Array(digest);
    let binary = '';
    for (let i = 0; i < arr.length; i++) {
        binary += String.fromCharCode(arr[i]);
    }
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
//# sourceMappingURL=state-hash.js.map